
import PropTypes from 'prop-types';
import { TableRow, TableCell, Checkbox, Avatar, Button, ListItemText, Table, Tooltip, MenuItem, IconButton } from "@mui/material";
import CustomPopover, {usePopover} from '../../../components/custom-popover/index.js';
import Iconify from "../../../components/iconify/iconify.js";
import { ConfirmDialog } from '../../../components/custom-dialog/index.js';
import { useBoolean } from '../../../hooks/use-boolean.js';
import { parseISO, format } from 'date-fns';
import {courseMode} from '../../../util/course.js';

export default function CompanyTableRow({
    row, selected, onSelected, onDeleteRow, onEditRow, onViewRow, onSelectRow
}){
    const { _id, courseTitle, mediumInstruction, courseSkillCode, tsgRefNumber, courseRunMode, approvalDate, validUntil} = row;
    const popover = usePopover();
    const confirm = useBoolean();


 return (
    <>
    <TableRow hover selected={selected}>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{tsgRefNumber}</TableCell>
            <TableCell>{courseTitle}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{courseMode.map((res)=> res.id === courseRunMode ? res.value : '')}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{mediumInstruction}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{format(parseISO(approvalDate), "dd/MM/yyyy")}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{format(parseISO(validUntil), "dd/MM/yyyy")}</TableCell>
            <TableCell align="right" sx={{px: 1, whiteSpace: 'nowrap'}}>
                    <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
            </TableCell>
    </TableRow>
    <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{width: 180}}
    >

        <MenuItem onClick={onEditRow}>
            <Iconify icon="solar:pen-bold" />
            Update
        </MenuItem>

        <MenuItem onClick={() => {
            confirm.onTrue();
            popover.onClose();
         }} sx={{ color: 'error.main'}}>
            <Iconify icon="solar:trash-bin-trash-bold" />
            Delete
        </MenuItem>
            


    </CustomPopover>

    <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content={`Are you sure want to delete ${courseTitle}?`}
        action={
          <Button variant="contained" color="error" onClick={onDeleteRow}>
            Delete
          </Button>
        }
      />

</>
 )

}

CompanyTableRow.propTypes = {
    onViewRow: PropTypes.func,
  };
  